import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"


const getReceiptDetail = (state) => {
    return axios.get(API + "receipts/viewDetails/receipts/"+state+"/",{headers: authHeader(),});
  };

  const DetailsReceiptService = {
    getReceiptDetail,
    };
export default DetailsReceiptService;